/*@flow*/

export default class CustomError<T = Response> extends Error {
  response: T;
}
